// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"23":"62763e8e","309":"69ddd6bb","510":"06993526","684":"1a738af8","822":"73e5dcc9"}[chunkId] + ".chunk.css";
};